/**
 * @file Patient board adapter.
 */

import { renderPatientKanban } from "../../shared/board/parentBoardKanban.js";
import { renderPatientWIPKanban } from "../../shared/board/parentBoardWipKanban.js";
import { renderPatientTable } from "../../shared/board/parentBoardTable.js";
import { createParentBoardAdapter } from "../../shared/board/parentBoardAdapterFactory.js";

export const patientBoardAdapter = createParentBoardAdapter({
  adapterKey: "patient",
  viewKey: "patients",
  renderers: {
    table: renderPatientTable,
    kanban: renderPatientKanban,
    wipKanban: renderPatientWIPKanban,
  },
});
